import { render, staticRenderFns } from "./SaldoInativo.vue?vue&type=template&id=7ee1baa7&scoped=true&"
import script from "./SaldoInativo.vue?vue&type=script&lang=js&"
export * from "./SaldoInativo.vue?vue&type=script&lang=js&"
import style0 from "./SaldoInativo.vue?vue&type=style&index=0&id=7ee1baa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee1baa7",
  null
  
)

export default component.exports